module.exports = __webpack_public_path__ + "static/img/2.1c96f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/2.png
// module id = lbSw
// module chunks = 1